import * as React from 'react';
import {
  Popover, Box, Card, Typography, Link, Avatar, Button, useTheme, Divider, Badge, styled
} from '@mui/material'
import PageWrapperBox from 'components/PageWrapperBox';

import {Adsense} from '@ctrl/react-adsense';
import ActivePlayersChart from './ActivePlayersChart';
import { useFavorites } from 'assets/favorites';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchData } from 'assets/utils';
import { WinIcon } from 'assets/Icons';
import {RecentResults} from 'components/RecentResults'
import AdComponent from './AdComponent';
import { HomeActivity } from './HomeActivity';
import InfoBox from './InfoBox';
import OutlinedBox from 'components/OutlinedBox';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ShadowBox from 'components/ShadowBox';
import { useActivity, getInitials } from 'assets/utils';
import { useTranslation, Trans } from "react-i18next";

// Calculation starts on Monday of week 20 (https://www.tennisenpadelvlaanderen.be/tennis/klassementen).
const nextRankingDate = new Date("2027-05-17T00:00:00")

export default () => {

    const favorites = useFavorites();
    const theme = useTheme();
    const { t } = useTranslation();

    return <>

            <PageWrapperBox>
            <Typography variant="h6" fontWeight="bold" color="primary" component="div">
            {t("news.versionLabel")} 3.0.2
        </Typography>
        <Typography variant="body2" component="div" color="text.primary" fontWeight="light">
            {t("news.versionDate")}
        </Typography>
            </PageWrapperBox>

        <Box sx={{paddingTop: '30px', marginBottom: '30px', width: "100%", mb: 4}}>
        {/*<Adsense
            client="ca-pub-9305958838449958"
            slot="7606688936"
            style={{ display: 'block'}}
            //layoutKey='-e5+6h-32-8b+ql'
            //layout="in-article"
            //format="fluid"
        />*/}
        <AdComponent/>
        </Box>

        <InfoBox title={t("news.rankingTitle")} color={theme.palette.primary.main} titleColor={theme.palette.primary.dark} backgroundColor="#F6FBFF">
            <Trans
                i18nKey="news.rankingBody"
                values={{
                    days: Math.ceil((nextRankingDate - new Date()) / (1000 * 60 * 60 * 24)),
                    date: nextRankingDate.toLocaleDateString(t("dates.locale"))
                }}
                components={{ b: <b style={{color: theme.palette.primary.dark}} /> }}
            />
        </InfoBox>

        {favorites.length > 0 ? <FavoritesSection favorites={favorites}/> : null}
        
        <ActivePlayersChart/>

        <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div" sx={{pt: 4}} >
        {t("news.whatsNew")}
        </Typography>

        <Typography variant="body" color="text.primary_bold" component="div">
            <ul>
                <li>{t("news.newItem1")}</li>
                <li>{t("news.newItem2")}</li>
            </ul>
        </Typography>
  </>}

function isPlayerActive(playerId, activity) {
    if (!activity) {
        return false;
    }
    
    const doublesActivity = activity?.activity?.doubles?.filter(el => el.my_id == playerId || el.p_id == playerId || el.o1_id == playerId || el.o2_id == playerId);
    if (doublesActivity && doublesActivity.length > 0) {
        return true;
    }

    const singlesActivity = activity?.activity?.singles?.filter(el => el.my_id == playerId || el.o_id == playerId);
    if (singlesActivity && singlesActivity.length > 0) {
        return true;
    }
}

function FavoritesSection({favorites}) {
    const { t } = useTranslation();
    const playerIds = React.useMemo(() => favorites.map(el => el.playerId), [favorites]);
    const activity = useActivity(playerIds);

    return <>


        <Typography variant="h6" component="div" fontWeight="bold" color="text.primary_bold" sx={{textTransform: "capitalize", pt: 4}}>
        {t("news.favorites")}
        </Typography>

        <ShadowBox sx={{mt: 2, mb: 3}}>

        {favorites.map((el, index) => <SmallPlayerCard key={el.playerId} player={el} index={index} sx={{pt: index == 0 ? 0.75 : 0.5, pb: index == favorites.length - 1 ? 0.75 : 0.5}} active={isPlayerActive(el.playerId, activity)}/>)}

        </ShadowBox>

        {/*<RecentResults favorites={favorites}/>*/}

        <HomeActivity activity={activity}/>

    </>
  }

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.light,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      //animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

function SmallPlayerCard({player, index, sx, active}) {
    const navigate = useNavigate();

    const theme = useTheme();

    const navigateToPlayer = () => fetchData(player.playerId, null, (content) => {navigate("/speler/" + player.playerId, {state: {...content, ts: new Date().getTime()}})})

    const avatar = <Avatar sx={{bgcolor: (theme) => theme.palette.primary.main, fontSize: 14, width: 36, height: 36}}>{getInitials(player?.name)}</Avatar>;

    return <>
    {index > 0 ? <Divider/> : null}
    <Button onClick={navigateToPlayer} disableRipple sx={{pl: 1, py: 0.5, textTransform: "capitalize", display: "flex", width: "100%", justifyContent: "flex-start", ...sx}}>
    
    {active ? <StyledBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        variant="dot"
      >
        {avatar}
    </StyledBadge> : avatar}

    <Box sx={{display: "flex", flexDirection: "column", alignItems: "flex-start", width: "100%", marginLeft: 1}} >
        <Typography variant="caption" fontWeight="bold" color="primary" component="div" sx={{fontSize: 14}}>
            {player.name}
        </Typography>
        <Typography variant="caption" component="div" color="text.secondary" sx={{fontSize: 12}}>
            {player.club}
        </Typography>        
    </Box>
    <ChevronRightIcon sx={{ml: "auto", color: theme.palette.primary.main}}/>
    </Button>
    </>
} 